import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_marketing-trustpilot_testimonials-view';
/**
 * User views trustpilot widget in the testimonials carousel
 */
export function trackRetailerMarketingTrustpilotTestimonialsView() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
